import { Row, Text } from "@/components";

const NUMBER_CLASS_NAMES = {
  sm: "text-sm tabular-nums text-slate-600",
  xs: "text-xs font-normal tabular-nums text-slate-500",
};

const TEXT_CLASS_NAMES = {
  sm: "text-xs text-slate-600",
  xs: "text-[10px] font-normal text-slate-500",
};

export const CommuteTime = ({
  durationSeconds,
  variant,
}: {
  durationSeconds: number;
  variant: "sm" | "xs";
}) => {
  const numberClassName = NUMBER_CLASS_NAMES[variant];
  const textClassName = TEXT_CLASS_NAMES[variant];
  const totalMinutes = Math.round(durationSeconds / 60);

  /* Render */
  const render = () => {
    if (totalMinutes < 60) {
      return (
        <Row className="items-baseline">
          <Text className={numberClassName}>{totalMinutes.toString()}</Text>
          <Text className={`ml-1 ${textClassName}`}>min</Text>
        </Row>
      );
    }

    const hours = Math.floor(totalMinutes / 60);
    const remMinutes = totalMinutes % 60;

    return (
      <Row className="items-baseline">
        <Text className={numberClassName}>{hours.toString()}</Text>
        <Text className={textClassName}>h</Text>
        {remMinutes > 0 && (
          <>
            <Text className={`ml-1 ${numberClassName}`}>
              {remMinutes.toString()}
            </Text>
            <Text className={textClassName}>m</Text>
          </>
        )}
      </Row>
    );
  };

  return render();
};
